import React from 'react';

/**
 * Cinematic hero header used on subpages (Properties, Blog, Contact, Invest)
 * to break the visual monotony of the plain beige `#E6DCCA` blocks that
 * previously sat above the page content.
 *
 * Same proportions as the regional hero (CostaBlanca/Calida/Almeria) so the
 * visual language stays consistent across the whole site. Mobile gets a
 * shorter hero (45vh / min 320px) to avoid pushing content too far down.
 */
const PageHero = ({ image, title, subtitle, testIdTitle, overlay = 0.45, align = 'center' }) => (
  <div style={styles.hero}>
    <div
      style={{
        ...styles.heroImage,
        backgroundImage: `url(${image})`,
      }}
    />
    <div style={{ ...styles.heroOverlay, backgroundColor: `rgba(26, 25, 24, ${overlay})` }} />
    <div style={{ ...styles.heroContent, textAlign: align }}>
      <h1 style={styles.heroTitle} data-testid={testIdTitle}>{title}</h1>
      {subtitle && <p style={styles.heroSubtitle}>{subtitle}</p>}
    </div>
  </div>
);

const styles = {
  hero: {
    position: 'relative',
    width: '100%',
    height: 'clamp(320px, 45vh, 520px)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
    marginBottom: '3rem',
  },
  heroImage: {
    position: 'absolute',
    inset: 0,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  },
  heroOverlay: {
    position: 'absolute',
    inset: 0,
  },
  heroContent: {
    position: 'relative',
    zIndex: 2,
    color: 'white',
    padding: '0 1.5rem',
    maxWidth: '900px',
  },
  heroTitle: {
    fontFamily: "'Playfair Display', serif",
    fontSize: 'clamp(2.4rem, 5.5vw, 4.5rem)',
    fontWeight: 400,
    lineHeight: 1.1,
    margin: '0 0 1rem',
  },
  heroSubtitle: {
    fontSize: 'clamp(1rem, 1.6vw, 1.25rem)',
    fontWeight: 300,
    margin: 0,
    opacity: 0.95,
  },
};

export default PageHero;
